<!-- Ticket Sidebar Container -->
<div class="ticket-sidebar-wrapper">
  <!-- Main Sidebar -->
  <div class="ticket-sidebar" [@sidebarCollapse]="getSidebarAnimationState()"
    [class.ticket-sidebar--collapsed]="isCollapsed">

    <!-- Sidebar Header -->
    <div class="ticket-sidebar__header">
      <!-- Ticket Icon & Info -->
      <div class="ticket-sidebar__ticket-info">
        <div class="ticket-info__icon">
          <mat-icon class="hash-icon">confirmation_number</mat-icon>
        </div>
        <div class="ticket-info__details">
          <div class="ticket-info__project">Ticket</div>
          <div class="ticket-info__ticket-id" [matTooltip]="ticketCode || (mode === 'create' ? 'New Ticket' : 'N/A')">
            {{ ticketCode || (mode === 'create' ? 'New Ticket' : 'N/A') }}
          </div>
        </div>
      </div>

      <!-- Collapse Button -->
      <button type="button" class="sidebar-collapse-btn" (click)="collapseSidebar()"
        [attr.aria-label]="'Collapse sidebar'">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>

    <!-- Search Input (View Mode Only) -->
    @if (!isCollapsed && isViewMode) {
      <div class="ticket-sidebar__search">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" class="search-input" [value]="searchQuery" (input)="onSearchInput($event)"
          placeholder="Search ticket details..." [attr.aria-label]="'Search ticket details'">
      </div>
    }

    <!-- Sidebar Content (scrollable sections) -->
    @if (!isCollapsed) {
      <div class="ticket-sidebar__content" [ngClass]="{'ticket-sidebar__content--no-search': mode !== 'view'}"
        >
        <!-- PRE-STATUS SECTION: SELF ASSIGN / MODULE / REFERENCE (Create Mode Only) -->
        @if (showModuleControls && mode === 'create') {
          <div class="sidebar-section">
            <div class="section-content">
              <!-- Row 1: Self assign toggle -->
              <div class="form-field form-field--inline">
                <label class="field-label">Self assign</label>
                <mat-slide-toggle class="toggle-input" [checked]="$any(ticketForm?.get('self_assign')?.value) == 1"
                (change)="onSelfAssignToggle($event)"></mat-slide-toggle>
              </div>
              <!-- Module dropdown (hidden when self-assign is on) -->
              @if (!($any(ticketForm?.get('self_assign')?.value) == 1)) {
                <div class="form-field">
                  <label class="field-label">Select Module</label>
                  <div class="custom-select custom-select--module">
                    <select class="select-input" [formControl]="$any(ticketForm?.get('module_id'))"
                      (change)="onModuleChange($any($event.target).value)"
                      [disabled]="isReadOnly || !modules || modules.length === 0">
                      <option [value]="null" disabled>Select Module</option>
                      @for (m of modules; track m) {
                        <option [value]="m.id">{{ m.name }}</option>
                      }
                    </select>
                    <mat-icon class="select-icon">expand_more</mat-icon>
                  </div>
                </div>
              }
              <!-- Reference Number search (typeahead, hidden when self-assign is on) -->
              @if (!($any(ticketForm?.get('self_assign')?.value) == 1)) {
                <div class="form-field">
                  <label class="field-label">Select reference number</label>
                  <ng-select [items]="(referenceSearchResults$ | async) ?? []" bindLabel="name" [typeahead]="referenceSearchInput$"
                    [loading]="referenceSearchLoading" [searchable]="true" [clearable]="true"
                    [disabled]="!ticketForm?.get('module_id')?.value || isReadOnly" placeholder="Search..."
                    (change)="onReferenceSelect($event)" class="user-search-select">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="user-option">
                        <span class="user-name">{{ item.name }}</span>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp>
                      <div class="no-results">
                        <mat-icon>search_off</mat-icon>
                        <span>No results</span>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              }
            </div>
          </div>
        }
        <!-- STATUS & PRIORITY SECTION -->
        <div class="sidebar-section">
          <h3 class="section-header">STATUS & PRIORITY</h3>
          <div class="section-content">
            <!-- Status Dropdown (with colors and lock icons) -->
            <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
              <label class="field-label">Status</label>
              <mat-select class="status-select" [formControl]="$any(ticketForm?.get('status'))"
                (selectionChange)="onStatusChange($event)" placeholder="Select status..."
                [disabled]="isLocked" panelClass="status-select-panel">
                <!-- Custom Trigger -->
                <mat-select-trigger>
                  <div class="status-trigger-content">
                    <span class="status-color-dot" [style.background-color]="getSelectedStatusColor()"></span>
                    <span class="status-trigger-name">
                      {{ getSelectedStatusName() || 'Select status...' }}
                      @if (getSelectedStatusLocked()) {
                        <mat-icon class="status-lock-icon" inline="true">
                          lock
                        </mat-icon>
                      }
                    </span>
                  </div>
                </mat-select-trigger>
                <!-- Options -->
                @for (status of statuses; track status) {
                  <mat-option [value]="status.id" class="status-option">
                    <div class="status-item">
                      <span class="status-color-dot" [style.background-color]="status.color"></span>
                      <span class="status-item-name">
                        {{ status.name }}
                        @if (status.lock_status) {
                          <mat-icon class="status-lock-icon" inline="true">lock</mat-icon>
                        }
                      </span>
                    </div>
                  </mat-option>
                }
              </mat-select>
            </div>
            <!-- Priority Dropdown (4-level scale) -->
            <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
              <label class="field-label">Priority</label>
              <div class="custom-select">
                <select class="select-input" [formControl]="$any(ticketForm?.get('priority'))"
                  (change)="onPriorityChange(+$any($event.target).value)" [disabled]="isReadOnly || isLocked">
                  <option [value]="1">Low</option>
                  <option [value]="2">Medium</option>
                  <option [value]="3">High</option>
                  <option [value]="4">Urgent</option>
                </select>
                <mat-icon class="select-icon">expand_more</mat-icon>
              </div>
            </div>
          </div>
        </div>
        <!-- TAGS SECTION - Unified for All Modes -->
        <div class="sidebar-section" [ngClass]="{'permission-disabled': isLocked}">
          <h3 class="section-header">TAGS</h3>
          <div class="section-content">
            <!-- Unified Tags Display -->
            <div class="tags-dropdown-wrapper">
              <!-- Normal Chips Display (When Dropdown Closed) -->
              @if (!isTagsDropdownOpen) {
                <div class="tags-container">
                  <!-- Empty State -->
                  @if (displayedTags.length === 0) {
                    <div class="tags-empty-state" [class.clickable]="!isReadOnly && !isLocked" (click)="!isReadOnly && !isLocked && openTagsDropdown()"
                      >
                      <span>No tags added to this ticket</span>
                    </div>
                  }
                  <!-- Chip Zone -->
                  @if (displayedTags.length > 0) {
                    <div class="tags-chip-zone" [class.clickable]="!isReadOnly && !isLocked" (click)="!isReadOnly && !isLocked && openTagsDropdown()"
                      >
                      @for (tag of displayedTags; track tag; let i = $index) {
                        <div class="tag-chip"
                          [style.background-color]="getTagBackgroundColor(tag.color)"
                          [style.color]="getTagTextColor(tag.color)">
                          <span class="tag-name">{{ tag.name || tag.tag }}</span>
                          <!-- Remove button enabled in view mode too (only disabled when isReadOnly or isLocked) -->
                          @if (!isReadOnly && !isLocked) {
                            <button type="button" class="tag-remove-btn"
                              (click)="removeTagFromDisplayed(i); $event.stopPropagation()" [attr.aria-label]="'Remove tag'">
                              <mat-icon>close</mat-icon>
                            </button>
                          }
                        </div>
                      }
                    </div>
                  }
                  <!-- Create and Add Tag Button -->
                  @if (!isReadOnly && !isLocked) {
                    <button type="button" class="tag-add-btn" (click)="openTagSelector()"
                      [attr.aria-label]="'Create and add tag'">
                      <mat-icon>add</mat-icon>
                      <span>Create and Add Tag</span>
                    </button>
                  }
                </div>
              }
              <!-- ng-select Multi-Select (When Dropdown Open - Now works in view mode too) -->
              @if (isTagsDropdownOpen && !isReadOnly && !isLocked) {
                <div class="tags-ng-select-wrapper">
                  <ng-select [items]="combinedTagsForDropdown" bindLabel="name" [compareWith]="compareTags"
                    [trackByFn]="trackByTagName" [multiple]="true" [closeOnSelect]="false" [searchable]="true"
                    [clearable]="true" [hideSelected]="false" placeholder="Search or select tags..."
                    [(ngModel)]="selectedTagsForDropdown" (change)="onTagsSelectChange($event)"
                    (open)="isTagsDropdownOpen = true" (close)="closeTagsDropdown()" class="tags-ng-select"
                    [class.ng-select-focused]="isTagsDropdownOpen" #tagsNgSelect>
                    <!-- Custom Tag Template (Chips inside input) -->
                    <ng-template ng-label-tmp let-item="item">
                      <div class="ng-select-tag-chip" [style.color]="getTagTextColor(item.color)"
                        [style.border-color]="getTagTextColor(item.color)">
                        <span>{{ item.name || item.tag }}</span>
                      </div>
                    </ng-template>
                    <!-- Custom Option Template (Dropdown items with checkmarks) -->
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                      <div class="tag-dropdown-item">
                        <span class="tag-color-dot" [style.background-color]="getTagTextColor(item.color)"></span>
                        <span class="tag-item-name">{{ item.name || item.tag }}</span>
                        @if (isTagSelectedInDropdown(item)) {
                          <mat-icon class="tag-check-icon">check</mat-icon>
                        }
                      </div>
                    </ng-template>
                    <!-- Not Found Template -->
                    <ng-template ng-notfound-tmp>
                      <div class="tag-not-found">
                        <span>No tags found</span>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              }
            </div>
          </div>
        </div>
        <!-- TICKET DETAILS SECTION (ticket-specific fields) -->
        <div class="sidebar-section">
          <h3 class="section-header">TICKET DETAILS</h3>

          <!-- These fields are resolved against the chosen module + record (the
               scope list in particular), so they stay locked until both are set. -->
          @if (!isContextReady) {
            <p class="section-locked-hint">
              <mat-icon>lock</mat-icon>
              <span>Select a module and reference number first.</span>
            </p>
          }

          <div class="section-content" [class.section-content--locked]="!isContextReady"
               [attr.inert]="!isContextReady ? '' : null"
               [attr.aria-disabled]="!isContextReady">
            <!-- Ticket Type -->
            <div class="form-field">
              <label class="field-label">Ticket Type</label>
              <!-- VIEW MODE: Plain text display -->
              @if (isViewMode || isReadOnly) {
                <div class="field-value">
                  {{ getSelectedTicketTypeName() || 'Not set' }}
                </div>
              }
              <!-- CREATE/EDIT MODE: Select dropdown -->
              @if (!isViewMode && !isReadOnly) {
                <div class="custom-select">
                  <select class="select-input" [formControl]="$any(ticketForm?.get('ticket_type_id'))"
                    (change)="onTicketTypeChange($any($event.target).value)">
                    <option [value]="null">Select Type</option>
                    @for (type of ticketTypes; track type) {
                      <option [value]="type.id">{{ type.name }}</option>
                    }
                  </select>
                  <mat-icon class="select-icon">expand_more</mat-icon>
                </div>
              }
            </div>
            <!-- Scopes (Multi-select) -->
            <div class="form-field">
              <label class="field-label">Scopes</label>
              <!-- VIEW MODE: Plain text display -->
              @if (isViewMode || isReadOnly) {
                <div class="field-value">
                  {{ getSelectedScopesDisplay() || 'Not set' }}
                </div>
              }
              <!-- CREATE/EDIT MODE: ng-select multi-select -->
              @if (!isViewMode && !isReadOnly) {
                <ng-select [items]="scopes" bindLabel="name" bindValue="id"
                  [multiple]="true" [formControl]="$any(ticketForm?.get('scopes'))" (change)="onScopesChange($event)"
                  placeholder="Select scopes" class="user-search-select">
                </ng-select>
              }
            </div>
            <!-- Customer -->
            <div class="form-field">
              <label class="field-label">Customer</label>
              <!-- VIEW MODE: Plain text display (matches task pattern) -->
              @if (isViewMode || isReadOnly) {
                <div class="field-value">
                  {{ selectedCustomer?.company_name || selectedCustomer?.name || 'Not set' }}
                </div>
              }
              <!-- CREATE/EDIT MODE: ng-select with search -->
              @if (!isViewMode && !isReadOnly) {
                <ng-select [items]="(customerSearchResults$ | async) ?? []"
                  [typeahead]="customerSearchInput$" [loading]="customerSearchLoading" bindLabel="company_name"
                  bindValue="id" [formControl]="$any(ticketForm?.get('customer'))" (change)="onCustomerChange($event)"
                  placeholder="Search customer..." class="user-search-select">
                </ng-select>
              }
            </div>
            <!-- Contact -->
            @if (selectedContact || (!isViewMode && ticketForm?.get('customer')?.value)) {
              <div class="form-field">
                <label class="field-label">Contact</label>
                <!-- VIEW MODE: Plain text display -->
                @if (isViewMode || isReadOnly) {
                  <div class="field-value">
                    {{ selectedContact?.full_name || selectedContact?.name || 'Not set' }}
                  </div>
                }
                <!-- CREATE/EDIT MODE: dropdown -->
                @if (!isViewMode && !isReadOnly) {
                  <div class="custom-select">
                    <select class="select-input" [formControl]="$any(ticketForm?.get('contact'))"
                      (change)="onContactChange($any($event.target).value)">
                      <option [value]="null">Select Contact</option>
                      @for (contact of contacts; track contact) {
                        <option [value]="contact.id">
                          {{ contact.full_name || contact.name }}
                        </option>
                      }
                    </select>
                    <mat-icon class="select-icon">expand_more</mat-icon>
                  </div>
                }
              </div>
            }
            <!-- Vendor -->
            <div class="form-field">
              <label class="field-label">Vendor</label>
              <!-- VIEW MODE: Plain text display -->
              @if (isViewMode || isReadOnly) {
                <div class="field-value">
                  {{ selectedVendor?.name || 'Not set' }}
                </div>
              }
              <!-- CREATE/EDIT MODE: ng-select -->
              @if (!isViewMode && !isReadOnly) {
                <ng-select [items]="(vendorSearchResults$ | async) ?? []"
                  [typeahead]="vendorSearchInput$" [loading]="vendorSearchLoading" bindLabel="name" bindValue="id"
                  [formControl]="$any(ticketForm?.get('vendor'))" (change)="onVendorChange($event)"
                  placeholder="Search vendor..." class="user-search-select">
                </ng-select>
              }
            </div>
            <!-- Subcontractor -->
            <div class="form-field">
              <label class="field-label">Subcontractor</label>
              <!-- VIEW MODE: Plain text display -->
              @if (isViewMode || isReadOnly) {
                <div class="field-value">
                  {{ selectedSubcontractor?.name || 'Not set' }}
                </div>
              }
              <!-- CREATE/EDIT MODE: ng-select -->
              @if (!isViewMode && !isReadOnly) {
                <ng-select [items]="(subcontractorSearchResults$ | async) ?? []"
                  [typeahead]="subcontractorSearchInput$" [loading]="subcontractorSearchLoading" bindLabel="name"
                  bindValue="id" [formControl]="$any(ticketForm?.get('subcontractor'))"
                  (change)="onSubcontractorChange($event)" placeholder="Search subcontractor..." class="user-search-select">
                </ng-select>
              }
            </div>
            <!-- Responsible Party -->
            <div class="form-field">
              <label class="field-label">Responsible Party</label>
              <!-- VIEW MODE: Plain text display -->
              @if (isViewMode || isReadOnly) {
                <div class="field-value">
                  {{ selectedResponsibleParty?.name || 'Not set' }}
                </div>
              }
              <!-- CREATE/EDIT MODE: Select dropdown -->
              @if (!isViewMode && !isReadOnly) {
                <div class="custom-select">
                  <select class="select-input" [formControl]="$any(ticketForm?.get('party_id'))"
                    (change)="onResponsiblePartyChange($any($event.target).value)">
                    <option [value]="null">Select Responsible Party</option>
                    @for (party of responsibleParties; track party) {
                      <option [value]="party.id">
                        {{ party.name }}
                      </option>
                    }
                  </select>
                  <mat-icon class="select-icon">expand_more</mat-icon>
                </div>
              }
            </div>
          </div>
        </div>
        <!-- DATES & MILESTONES SECTION -->
        <div class="sidebar-section">
          <h3 class="section-header">DATES</h3>
          <div class="section-content">
            <!-- Due Date -->
            <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
              <label class="field-label">Due Date</label>
              <input type="date" class="date-input" [formControl]="$any(ticketForm?.get('due_date'))"
                [disabled]="isViewMode || isReadOnly || isLocked">
            </div>
            <!-- Milestone Selector -->
            <div class="form-field">
              <label class="field-label">Milestone</label>
              <!-- Selected Milestone Display -->
              @if (selectedMilestone) {
                <div class="milestone-selected">
                  <div class="milestone-icon">
                    <mat-icon>flag</mat-icon>
                  </div>
                  <span class="milestone-name">{{ selectedMilestone.name }}</span>
                  @if (mode !== 'view' && !isReadOnly && !isLocked) {
                    <button type="button" class="milestone-remove-btn"
                      (click)="removeMilestone()" [attr.aria-label]="'Remove milestone'">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </div>
              }
              <!-- Add Milestone Button -->
              <!--
              <button type="button"
                class="milestone-add-btn"
                *ngIf="!selectedMilestone && mode !== 'view' && !isReadOnly"
                (click)="toggleMilestoneSelector()"
                [attr.aria-label]="'Attach to milestone'">
                <mat-icon>add</mat-icon>
                <span>Attach to Milestone</span>
              </button>
              -->
              <!-- Milestone Selector Popup -->
              @if (showMilestoneSelector) {
                <div class="milestone-popup" #milestonePopup>
                  <div class="popup-header">Select Milestone</div>
                  <div class="popup-content">
                    @for (milestone of milestones; track milestone) {
                      <div class="milestone-item" (click)="selectMilestone(milestone)">
                        <!-- Status Indicator -->
                        <div class="milestone-status-dot" [class]="'status-' + milestone.status"></div>
                        <!-- Main Content -->
                        <div class="milestone-details">
                          <!-- Row 1: Name + Status Badge -->
                          <div class="milestone-header">
                            <div class="milestone-item-name">{{ milestone.name }}</div>
                            <span class="milestone-status-badge" [class]="getMilestoneStatusBadgeClass(milestone.status)">
                              {{ milestone.status }}
                            </span>
                          </div>
                          <!-- Row 2: Date Range -->
                          <div class="milestone-date-info">
                            <mat-icon class="date-icon">calendar_today</mat-icon>
                            @if (milestone.startDate && milestone.endDate) {
                              <span>
                                {{ milestone.startDate | date: 'MMM d' }} - {{ milestone.endDate | date: 'MMM d, yyyy' }}
                              </span>
                            }
                            @if (!milestone.startDate || !milestone.endDate) {
                              <span>
                                Due: {{ milestone.dueDate | date: 'mediumDate' }}
                              </span>
                            }
                            @if (milestone.daysRemaining && milestone.status !== 'completed' && milestone.status !== 'overdue') {
                              <span class="days-remaining"
                                >
                                • {{ milestone.daysRemaining }} left
                              </span>
                            }
                          </div>
                          <!-- Row 3: Progress Bar -->
                          @if (milestone.status === 'in-progress' && milestone.progress !== undefined) {
                            <div class="milestone-progress-row"
                              >
                              <div class="milestone-progress-bar">
                                <div class="progress-fill" [style.width.%]="milestone.progress"></div>
                              </div>
                              <span class="milestone-progress-text">{{ milestone.progress }}%</span>
                            </div>
                          }
                          <!-- Row 4: Task Stats -->
                          @if (milestone.taskStats) {
                            <div class="milestone-task-stats">
                              <mat-icon class="task-icon">check_circle_outline</mat-icon>
                              <span>{{ milestone.taskStats.completed }}/{{ milestone.taskStats.total }} tasks</span>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <!-- Created On (Read-only) -->
            <div class="form-field">
              <label class="field-label">Created On</label>
              <div class="field-value">{{ createdOn | date: 'mediumDate' }}</div>
            </div>
          </div>
        </div>
        <!-- TIME PLANNING SECTION (Collapsible) -->
        <div class="sidebar-section time-planning-section">
          <div class="section-header-collapsible" (click)="toggleTimePlanning()">
            <div class="section-title-wrapper">
              <mat-icon class="section-icon">schedule</mat-icon>
              <h3 class="section-header-inline">TIME PLANNING</h3>
            </div>
            <mat-icon class="expand-icon" [class.expanded]="isTimePlanningExpanded">
              {{ isTimePlanningExpanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </div>
          @if (isTimePlanningExpanded) {
            <div class="section-content">
              <!-- Start Date -->
              <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
                <label class="field-label">Start Task On</label>
                <input type="date" class="date-input" [value]="$any(ticketForm?.get('start_date')?.value)"
                  (change)="onStartDateChange($event)" [disabled]="isViewMode || isReadOnly || isLocked">
              </div>
              <!-- Duration -->
              <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
                <label class="field-label">Duration</label>
                <div class="duration-input-wrapper">
                  <input type="number" class="duration-input" [value]="ticketForm?.get('duration')?.value || ''"
                    (input)="onDurationChange($event)" [disabled]="isViewMode || isReadOnly || isLocked" placeholder="Enter duration"
                    min="0">
                  <span class="duration-unit">days</span>
                </div>
              </div>
              <!-- Finish Date -->
              <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
                <label class="field-label">Finish</label>
                <input type="date" class="date-input" [value]="$any(ticketForm?.get('date_finished')?.value)"
                  (change)="onFinishDateChange($event)" [disabled]="isViewMode || isReadOnly || isLocked">
              </div>
              <!-- Validation Error -->
              @if (timePlanningError) {
                <div class="validation-message error">
                  <mat-icon class="error-icon">error</mat-icon>
                  <span>{{ timePlanningError }}</span>
                </div>
              }
            </div>
          }
        </div>
        <!-- PEOPLE SECTION -->
        <div class="sidebar-section">
          <h3 class="section-header">PEOPLE</h3>
          <div class="section-content">
            <!-- Assignee (Responsible Person) -->
            <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
              <div class="field-header">
                <label class="field-label">Assignee</label>
                @if (!isViewMode && !isReadOnly && !isLocked) {
                  <button type="button" class="field-add-btn" (click)="openAssigneeSelector()"
                    >
                    <mat-icon>{{ showAssigneeSearch ? 'close' : 'add' }}</mat-icon>
                  </button>
                }
              </div>
              <!-- Person Type Filter -->
              @if (showAssigneeSearch && !isViewMode) {
                <div class="person-type-filter">
                  @for (type of personTypes; track type) {
                    <button type="button" [class.active]="activeAssigneePersonType === type"
                      (click)="setActiveAssigneePersonType(type)" class="type-filter-btn">
                      <mat-icon>{{ getPersonTypeIcon(type) }}</mat-icon>
                      <span>{{ type }}</span>
                    </button>
                  }
                </div>
              }
              <!-- Assignee List -->
              <div class="people-list">
                @for (person of assignees; track person; let i = $index) {
                  <div class="person-item">
                    <app-profile-avatar [fullName]="getPersonDisplayName(person)"
                      [profileUrl]="getPersonAvatar(person) || ''" widthSize="32px" heightSize="32px">
                    </app-profile-avatar>
                    <div class="person-info">
                      <span class="person-name">{{ getPersonDisplayName(person) }}</span>
                      <mat-icon class="person-type-icon" [title]="person.type">{{ getPersonTypeIcon(person.type)
                      }}</mat-icon>
                    </div>
                    @if (!isViewMode && !isReadOnly && !isLocked && person.type === 'Users') {
                      <button type="button" class="person-default-star-btn"
                        [class.is-default]="isPersonDefault(person, 'assignee')"
                        [matTooltip]="isPersonDefault(person, 'assignee') ? 'Default' : 'Set as default'"
                        [attr.aria-label]="isPersonDefault(person, 'assignee') ? 'Default' : 'Set as default'"
                        (click)="setSelectedAssigneeAsDefault(person, $event)">
                        <mat-icon>{{ isPersonDefault(person, 'assignee') ? 'star' : 'star_border' }}</mat-icon>
                      </button>
                    } @else if (isPersonDefault(person, 'assignee')) {
                      <mat-icon class="default-user-star" matTooltip="Default">star</mat-icon>
                    }
                    @if (!isViewMode && !isReadOnly && !isLocked) {
                      <button type="button" class="person-remove-btn"
                        (click)="removeAssignee(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </div>
                }
                <!-- Empty State -->
                @if (assignees.length === 0 && !showAssigneeSearch) {
                  <div class="empty-state">
                    No assignees
                  </div>
                }
              </div>
              <!-- Inline Search Wrapper (ng-select) -->
              @if (showAssigneeSearch && !isLocked) {
                <div class="inline-search-wrapper">
                  <ng-select #assigneeSelect [items]="assigneeItems" bindLabel="full_name"
                    [typeahead]="assigneeSearchInput$" [loading]="assigneeSearchLoading" [searchable]="true"
                    [clearable]="true" placeholder="Search..." (change)="onAssigneeSelect($event)"
                    (scrollToEnd)="onAssigneeScrollToEnd()"
                    class="user-search-select">
                    <ng-template ng-option-tmp let-item="item">
                      @if (item.__skeleton) {
                        <div class="user-option user-option-skeleton">
                          <div class="option-skeleton-avatar"></div>
                          <div class="option-skeleton-line"></div>
                        </div>
                      } @else {
                        <div class="user-option">
                          <app-profile-avatar [fullName]="item.full_name || item.name || item.company_name || ''"
                            [profileUrl]=" $any(item.profile_image)?.url || ''" widthSize="24px" heightSize="24px">
                          </app-profile-avatar>
                          <span class="user-name">{{ item.full_name || item.name || item.company_name }}</span>
                        </div>
                      }
                    </ng-template>
                  </ng-select>
                </div>
              }
            </div>
            <!-- Observers -->
            <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
              <div class="field-header">
                <label class="field-label">Observers</label>
                @if (!isViewMode && !isReadOnly && !isLocked) {
                  <button type="button" class="field-add-btn" (click)="openObserverSelector()"
                    >
                    <mat-icon>{{ showObserverSearch ? 'close' : 'add' }}</mat-icon>
                  </button>
                }
              </div>
              <!-- Person Type Filter -->
              @if (showObserverSearch && !isViewMode) {
                <div class="person-type-filter">
                  @for (type of personTypes; track type) {
                    <button type="button" [class.active]="activeObserverPersonType === type"
                      (click)="setActiveObserverPersonType(type)" class="type-filter-btn">
                      <mat-icon>{{ getPersonTypeIcon(type) }}</mat-icon>
                      <span>{{ type }}</span>
                    </button>
                  }
                </div>
              }
              <!-- Observer List -->
              <div class="people-list">
                @for (person of observers; track person; let i = $index) {
                  <div class="person-item">
                    <app-profile-avatar [fullName]="getPersonDisplayName(person)"
                      [profileUrl]="getPersonAvatar(person) || ''" widthSize="32px" heightSize="32px">
                    </app-profile-avatar>
                    <div class="person-info">
                      <span class="person-name">{{ getPersonDisplayName(person) }}</span>
                      <mat-icon class="person-type-icon" [title]="person.type">{{ getPersonTypeIcon(person.type)
                      }}</mat-icon>
                    </div>
                    @if (!isViewMode && !isReadOnly && !isLocked && person.type === 'Users') {
                      <button type="button" class="person-default-star-btn"
                        [class.is-default]="isPersonDefault(person, 'observer')"
                        [matTooltip]="isPersonDefault(person, 'observer') ? 'Default' : 'Set as default'"
                        [attr.aria-label]="isPersonDefault(person, 'observer') ? 'Default' : 'Set as default'"
                        (click)="setSelectedObserverAsDefault(person, $event)">
                        <mat-icon>{{ isPersonDefault(person, 'observer') ? 'star' : 'star_border' }}</mat-icon>
                      </button>
                    } @else if (isPersonDefault(person, 'observer')) {
                      <mat-icon class="default-user-star" matTooltip="Default">star</mat-icon>
                    }
                    @if (!isViewMode && !isReadOnly && !isLocked) {
                      <button type="button" class="person-remove-btn"
                        (click)="removeObserver(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </div>
                }
                <!-- Empty State -->
                @if (observers.length === 0 && !showObserverSearch) {
                  <div class="empty-state">
                    No observers
                  </div>
                }
              </div>
              <!-- Inline Search Wrapper -->
              @if (showObserverSearch && !isLocked) {
                <div class="inline-search-wrapper">
                  <ng-select #observerSelect [items]="observerItems" bindLabel="full_name"
                    [typeahead]="observerSearchInput$" [loading]="observerSearchLoading" [searchable]="true"
                    [clearable]="true" placeholder="Search..." (change)="onObserverSelect($event)"
                    (scrollToEnd)="onObserverScrollToEnd()"
                    class="user-search-select">
                    <ng-template ng-option-tmp let-item="item">
                      @if (item.__skeleton) {
                        <div class="user-option user-option-skeleton">
                          <div class="option-skeleton-avatar"></div>
                          <div class="option-skeleton-line"></div>
                        </div>
                      } @else {
                        <div class="user-option">
                          <app-profile-avatar [fullName]="item.full_name || item.name || item.company_name || ''"
                            [profileUrl]="$any(item.profile_image)?.url || ''" widthSize="24px" heightSize="24px">
                          </app-profile-avatar>
                          <span class="user-name">{{ item.full_name || item.name || item.company_name || '' }}</span>
                        </div>
                      }
                    </ng-template>
                  </ng-select>
                </div>
              }
            </div>
            <!-- Participants -->
            <div class="form-field" [ngClass]="{'permission-disabled': isLocked}">
              <div class="field-header">
                <label class="field-label">Participants</label>
                @if (!isViewMode && !isReadOnly && !isLocked) {
                  <button type="button" class="field-add-btn" (click)="openParticipantSelector()"
                    >
                    <mat-icon>{{ showParticipantSearch ? 'close' : 'add' }}</mat-icon>
                  </button>
                }
              </div>
              <!-- Person Type Filter -->
              @if (showParticipantSearch && !isViewMode) {
                <div class="person-type-filter">
                  @for (type of personTypes; track type) {
                    <button type="button"
                      [class.active]="activeParticipantPersonType === type" (click)="setActiveParticipantPersonType(type)"
                      class="type-filter-btn">
                      <mat-icon>{{ getPersonTypeIcon(type) }}</mat-icon>
                      <span>{{ type }}</span>
                    </button>
                  }
                </div>
              }
              <!-- Participant List -->
              <div class="people-list">
                @for (person of participants; track person; let i = $index) {
                  <div class="person-item">
                    <app-profile-avatar [fullName]="getPersonDisplayName(person)"
                      [profileUrl]="getPersonAvatar(person) || ''" widthSize="32px" heightSize="32px">
                    </app-profile-avatar>
                    <div class="person-info">
                      <span class="person-name">{{ getPersonDisplayName(person) }}</span>
                      <mat-icon class="person-type-icon" [title]="person.type">{{ getPersonTypeIcon(person.type)
                      }}</mat-icon>
                    </div>
                    @if (!isViewMode && !isReadOnly && !isLocked && person.type === 'Users') {
                      <button type="button" class="person-default-star-btn"
                        [class.is-default]="isPersonDefault(person, 'participant')"
                        [matTooltip]="isPersonDefault(person, 'participant') ? 'Default' : 'Set as default'"
                        [attr.aria-label]="isPersonDefault(person, 'participant') ? 'Default' : 'Set as default'"
                        (click)="setSelectedParticipantAsDefault(person, $event)">
                        <mat-icon>{{ isPersonDefault(person, 'participant') ? 'star' : 'star_border' }}</mat-icon>
                      </button>
                    } @else if (isPersonDefault(person, 'participant')) {
                      <mat-icon class="default-user-star" matTooltip="Default">star</mat-icon>
                    }
                    @if (!isViewMode && !isReadOnly && !isLocked) {
                      <button type="button" class="person-remove-btn"
                        (click)="removeParticipant(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </div>
                }
                <!-- Empty State -->
                @if (participants.length === 0 && !showParticipantSearch) {
                  <div class="empty-state">
                    No participants
                  </div>
                }
              </div>
              <!-- Inline Search Wrapper -->
              @if (showParticipantSearch && !isLocked) {
                <div class="inline-search-wrapper">
                  <ng-select #participantSelect [items]="participantItems" bindLabel="full_name"
                    [typeahead]="participantSearchInput$" [loading]="participantSearchLoading" [searchable]="true"
                    [clearable]="true" placeholder="Search..." (change)="onParticipantSelect($event)"
                    (scrollToEnd)="onParticipantScrollToEnd()"
                    class="user-search-select">
                    <ng-template ng-option-tmp let-item="item">
                      @if (item.__skeleton) {
                        <div class="user-option user-option-skeleton">
                          <div class="option-skeleton-avatar"></div>
                          <div class="option-skeleton-line"></div>
                        </div>
                      } @else {
                        <div class="user-option">
                          <app-profile-avatar [fullName]="item.full_name || item.name || item.company_name || ''"
                            [profileUrl]="$any(item.profile_image)?.url || ''" widthSize="24px" heightSize="24px">
                          </app-profile-avatar>
                          <span class="user-name">{{ item.full_name || item.name || item.company_name || '' }}</span>
                        </div>
                      }
                    </ng-template>
                  </ng-select>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Sidebar Footer (Progress) -->
    @if (!isCollapsed) {
      <div class="ticket-sidebar__footer">
        <div class="progress-section">
          <div class="progress-header">
            <span class="progress-label">Ticket Progress</span>
            <span class="progress-percentage">
              <span class="completion-count">{{ completedCount }}/{{ totalCount }} items</span>
              <span class="completion-percent">{{ completionPercentage }}%</span>
            </span>
          </div>
          <div class="progress-bar-container">
            <div class="progress-bar-fill" [style.width.%]="completionPercentage">
            </div>
          </div>
        </div>
      </div>
    }

  </div>

  <!-- Collapsed Sidebar Toggle Button -->
  @if (isCollapsed) {
    <button type="button" class="sidebar-toggle-collapsed"
      [@toggleButtonHover]="getToggleButtonAnimationState()" [@fadeInOut] (click)="expandSidebar()"
      (mouseenter)="isToggleButtonHovered = true" (mouseleave)="isToggleButtonHovered = false"
      [attr.aria-label]="'Expand sidebar'">
      <mat-icon>arrow_forward</mat-icon>
    </button>
  }
</div>